var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconArrowRightWards = function SvgIconArrowRightWards(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.502 10.542H4.958a.526.526 0 0 1-.541-.538.533.533 0 0 1 .54-.546h8.545L9.606 5.563a.55.55 0 0 1-.168-.379.54.54 0 0 1 .165-.4.52.52 0 0 1 .387-.168q.213.004.383.174l4.737 4.743q.104.106.153.22.048.116.048.25a.65.65 0 0 1-.192.462l-4.742 4.742a.5.5 0 0 1-.377.166.55.55 0 0 1-.377-.177.57.57 0 0 1-.173-.397q0-.213.173-.38z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowRightWards);
export { ForwardRef as ReactComponent };